import type { PostTheme } from '@/types';
import { produce } from 'immer';

const processPostTheme = (theme: PostTheme): PostTheme => {
  if (!theme) {
    return {} as PostTheme;
  }

  return produce(theme, (draft) => {
    Object.keys(draft).forEach((key) => {
      try {
        const _key = key as keyof PostTheme;
        const value = Number.parseInt(draft[_key], 10);
        if (!Number.isNaN(value) && !key.match(/h[1-6]_line_height/)) {
          // exceptions for percentage values
          if (['content_break_width'].includes(_key)) {
            draft[_key] = `${value}%`;
          } else if (_key.endsWith('_font_weight')) {
            draft[_key] = value;
          } else {
            // this is number, then set it to pixel
            draft[_key] = `${value}px`;
          }
        }
      } catch (e) {
        console.error(e);
      }
    });
  });
};

export { processPostTheme };
